// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

export const EarnedRewardsConfig = {
  emptyLabel: 'EarnedRewards',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/earnedRewards`,
};

const EarnedRewards = dynamic(() => import('./EarnedRewards').then(mod => mod.EarnedRewards));

export const EarnedRewardsEditable = (props: any) => {
  return (
    <EditableComponent config={EarnedRewardsConfig} {...props}>
      <EarnedRewards {...props} />
    </EditableComponent>
  );
};
